module.exports = __webpack_public_path__ + "static/media/like_stroke.7005f982.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/like_stroke.svg
// module id = 596
// module chunks = 0